import * as React from "react";

import { currentUserTheme, defaultThemeId, toggleTheme } from "../theming";

import { Button } from "azure-devops-ui/Button";
import { Observer } from "azure-devops-ui/Observer";

export interface IThemeToggleButtonProps {
    iconOnly?: boolean;
}

export default class ThemeToggleButton extends React.Component<IThemeToggleButtonProps> {
    public render(): JSX.Element {
        const { iconOnly } = this.props;

        return (
            <Observer theme={currentUserTheme}>
                {(props: { theme: string }) => (
                    <Button
                        text={iconOnly ? undefined : props.theme === defaultThemeId ? "Switch to dark theme" : "Switch to light theme"}
                        tooltipProps={
                            iconOnly ? { text: props.theme === defaultThemeId ? "Switch to dark theme" : "Switch to light theme" } : undefined
                        }
                        onClick={toggleTheme}
                        iconProps={{
                            render: () => <img alt="" className="custom-button-icon hc-invert-dark" src={require("../Images/theme.svg")} />
                        }}
                    />
                )}
            </Observer>
        );
    }
}
